import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
  isLoading: boolean;
};

const initialState: InitialState = {
  isLoading: false,
};

const changePasswordPageSlice = createSlice({
  name: "changePasswordPageSlice",
  initialState,
  reducers: {
    sendRequest: (state, action) => {
      state.isLoading = true;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default changePasswordPageSlice;
